import React from "react";
import ModalWrapper from "./ModalWrapper";
import { FiSearch } from "react-icons/fi";
import useSWR from "swr";
import { capitalize } from "Helper";
import { useFormContext } from "react-hook-form";

export default function CategoryModal({ label, name = "categories", onClose, error }) {
  const { watch, setValue } = useFormContext();
  const selected = watch(name) || [];
  const [search, setSearch] = React.useState("");
  const { data } = useSWR("/entertainment/movie-box/genres");
  const categories = data?.data?.map((item) => item.display_name) || [];

  const toggleSelect = (cat) => {
    if (selected.includes(cat)) {
      setValue(
        name,
        selected.filter((c) => c !== cat)
      );
    } else {
      setValue(name, [...selected, cat]);
    }
  };

  const handleSave = () => {
    onClose();
  };

  const filteredCategories = categories.filter((cat) =>
    cat.toLowerCase().includes(search.toLowerCase())
  );

  const [open, setOpen] = React.useState(false);
  return (
    <>
      <div>
        {label && <label className="block text-sm font-medium text-gray-700 pb-1">{label}</label>}
        <button
          type="button"
          onClick={() => setOpen((prev) => !prev)}
          className="flex items-center justify-between w-full p-3 bg-input border rounded-md text-left text-sm"
        >
          <span>{selected.length ? data?.data?.filter(item => selected.includes(item.display_name)).map(item => capitalize(item.display_name)).join(', ') : "Select Categories"}</span>
          {open ? (
            <svg className="h-4 w-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" /></svg>
          ) : (
            <svg className="h-4 w-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
          )}
        </button>
        {error && <p className="text-red-500 text-sm">{error}</p>}
      </div>

      {open && (
        <ModalWrapper onClose={() => setOpen(false)}>
          <div className="flex items-center border rounded px-2 py-1 mb-4">
            <FiSearch className="text-gray-500 mr-2" />
            <input
              type="text"
              placeholder="Search categories"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="w-full outline-none"
            />
          </div>

          <ul>
            {filteredCategories.map((cat) => (
              <li
                key={cat}
                className="flex items-center border-b py-2 cursor-pointer"
                onClick={() => toggleSelect(cat)}
              >
                <input
                  type="checkbox"
                  checked={data?.data?.find(item => item.display_name === cat) ? selected.includes(data?.data?.find(item => item.display_name === cat).display_name) : false}
                  onChange={() => toggleSelect(cat)}
                  className="mr-3 w-5 h-5"
                />
                <span>{capitalize(cat)}</span>
              </li>
            ))}
          </ul>

          <div className="flex justify-end mt-4">
            <button
              onClick={() => {
                setOpen(false);
                handleSave();
              }}
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
            >
              Save
            </button>
          </div>
        </ModalWrapper>
      )}
    </>
  );
}
